export default function scrollToElement($el, offset = 0) {
  const el = resolveElement($el)
  if (!el) return

  const container = findScrollableContainer(el)
  if (!container) return

  container.scrollTo({
    top: findPos(el) - offset,
    behavior: "smooth"
  })
}

function resolveElement($el) {
  if (!$el) return null
  if (Array.isArray($el)) return $el[$el.length - 1] || null
  return $el
}

function isScrollable($el) {
  // Compare the height to see if the element has scrollable content
  if ($el) {
    const hasScrollableContent = $el.scrollHeight > $el.clientHeight;

    // It's not enough because the element's `overflow-y` style can be set as
    // * `hidden`
    // * `hidden !important`
    // In those cases, the scrollbar isn't shown
    const overflowYStyle = window.getComputedStyle($el).overflowY;
    const isOverflowYScroll = ['scroll', 'auto'].includes(overflowYStyle)

    return hasScrollableContent && isOverflowYScroll;
  }

}

function findScrollableContainer($el) {
  if (!$el) return null
  if (isScrollable($el))
    return $el
  if (!$el.parentElement)
    return document.scrollingElement || document.documentElement
  return findScrollableContainer($el.parentElement)
}

function findPos(el) {
  var curtop = 0
  if (el.offsetParent) {
    do {
      curtop += el.offsetTop
    } while ((el = el.offsetParent))
    return curtop
  }
}